import "./responseModal.scss";

const ResponseModal = () => {
  return <></>;
};

export default ResponseModal;
